import React from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { useState } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import ActivityCard from "./activityCard";

// SwiperCore.use([Navigation, Pagination]);

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 60,
    marginBottom: 100,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 30,
  },
  box: {
    minHeight: "min(230px,55vw)",
  },
  maxWidth1024: {
    [theme.breakpoints.up("md")]: {
      maxWidth: "1042px",
      padding: "30px 0px",
    },
    backgroundColor: "#eee",
    borderRadius: "25px",
    marginBottom: "10px",
    "& .swiper": {
      width: "100%",
      height: "100%",
      paddingBottom: "10px",
      [theme.breakpoints.down("sm")]: {
        padding: "0 10px",
        paddingBottom: 110,
        paddingTop: "35px",
      },
    },
    "& .swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal":
      {
        bottom: "75px !important",
        left: "2px !important",
      },
    "& .swiper-pagination .swiper-pagination-bullet-active": {
      backgroundColor: "#00000099 !important",
    },
    "& .swiper-button-next": {
      [theme.breakpoints.down("sm")]: {
        left: "53% !important",
      },
      left: "51% !important",
      top: "93% !important",
      backgroundColor: "#fff",
      width: 45,
      borderRadius: "100%",
    },
    "& .swiper-button-prev": {
      [theme.breakpoints.down("sm")]: {
        left: "35.5% !important",
      },
      left: "44.5% !important",
      top: "93% !important",
      backgroundColor: "#fff",
      width: 45,
      borderRadius: "100%",
    },
    "& .swiper-button-next::after": {
      color: "#2dbbc0",
      fontWeight: "bold",
      fontSize: 19,
    },
    "& .swiper-button-prev::after": {
      color: "#2dbbc0",
      fontWeight: "bold",
      fontSize: 19,
    },
  },
}));
export function ActivitySlider({ data }) {
  const classes = useStyles();
  return (
    <Grid container className={classes.box}>
      <Grid container justify="center">
        <Grid container className={classes.maxWidth1024}>
          <Swiper
            spaceBetween={20}
            pagination
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              440: {
                slidesPerView: 1.4,
              },
              1024: {
                slidesPerView: 3.1,
              },
              // 1400: {
              // 	slidesPerView: 4.4,
              // },
              // 1800: {
              // 	slidesPerView: 5.3,
              // },
            }}
            // rtl={true}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
          >
            {data?.length > 0 &&
              data?.map((item, index) => (
                <SwiperSlide key={item.slug}>
                  <ActivityCard
                    activityTitle={item?.title}
                    slug={item?.slug}
                    commentCount={item?.comment_count}
                    driveCount={item.derive_count}
                    likeCount={item.like_count}
                    imgUrl={item?.thumbnail}
                    school={item?.unit_name}
                    viewCount={item?.view_count}
                    type={item.unit_location}
                    section={item?.section}
                    index={index}
                    tagColor="#0c78a1"
                  />
                </SwiperSlide>
              ))}
            {data?.length > 0 && <Grid className="swiper-button-prev"></Grid>}
            {data?.length > 0 && <Grid className="swiper-button-next"></Grid>}
          </Swiper>
        </Grid>
      </Grid>
    </Grid>
  );
}
